import { render } from "./SupportView.vue?vue&type=template&id=2faf1cca&scoped=true"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"

import "./SupportView.vue?vue&type=style&index=0&id=2faf1cca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faf1cca"],['__file',"src/views/SupportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2faf1cca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2faf1cca', __exports__)) {
    api.reload('2faf1cca', __exports__)
  }
  
  module.hot.accept("./SupportView.vue?vue&type=template&id=2faf1cca&scoped=true", () => {
    api.rerender('2faf1cca', render)
  })

}


export default __exports__